export const CONTEXT_TYPES = Object.freeze({
  INDIVIDUAL: 'individual',
  ORGANIZATION_ADMIN: 'organization_admin',
  CLUB_ADMIN: 'club_admin',
  COMMUNITY_ADMIN: 'community_admin',
  TOURNAMENT_ADMIN: 'tournament_admin',
  DEPARTMENT_ADMIN: 'department_admin',
});

export const ROLE_CONTEXT_LABELS = Object.freeze({
  [CONTEXT_TYPES.INDIVIDUAL]: 'Home',
  [CONTEXT_TYPES.ORGANIZATION_ADMIN]: 'Organization Admin',
  [CONTEXT_TYPES.CLUB_ADMIN]: 'Club Admin',
  [CONTEXT_TYPES.COMMUNITY_ADMIN]: 'Community Admin',
  [CONTEXT_TYPES.TOURNAMENT_ADMIN]: 'Tournament Admin',
  [CONTEXT_TYPES.DEPARTMENT_ADMIN]: 'Department Admin',
});

export const LANDING_ROUTES_BY_CONTEXT = Object.freeze({
  [CONTEXT_TYPES.INDIVIDUAL]: '/dashboard/individual/home',
  [CONTEXT_TYPES.ORGANIZATION_ADMIN]: '/dashboard/organization',
  [CONTEXT_TYPES.CLUB_ADMIN]: '/dashboard/club',
  [CONTEXT_TYPES.COMMUNITY_ADMIN]: '/dashboard/community',
  [CONTEXT_TYPES.TOURNAMENT_ADMIN]: '/dashboard/tournament-admin/tournaments',
  [CONTEXT_TYPES.DEPARTMENT_ADMIN]: '/team-admin',
});

export const DEFAULT_ROLE_CONTEXT = Object.freeze({
  type: CONTEXT_TYPES.INDIVIDUAL,
  entityType: null,
  entityId: null,
});

export const isKnownContextType = (type) => Object.values(CONTEXT_TYPES).includes(type);
